window.addEventListener("DOMContentLoaded", function () {

  const slider = document.getElementById("brandSlider");
  const sliderWrapper = document.querySelector(".brand-slider-wrapper");

  const leftArrow = document.getElementById("leftArrow");
  const rightArrow = document.getElementById("rightArrow");

  let scrollAmount = 0;
  const cardWidth = 260; // card + gap (adjust if needed)

  function updateSlider() {
    const maxScroll = slider.scrollWidth - sliderWrapper.clientWidth;

    if (scrollAmount < 0) scrollAmount = 0;
    if (scrollAmount > maxScroll) scrollAmount = maxScroll;

    slider.style.transform = `translateX(-${scrollAmount}px)`;
  }

  rightArrow.addEventListener("click", () => {
    scrollAmount += cardWidth;
    updateSlider();
  });

  leftArrow.addEventListener("click", () => {
    scrollAmount -= cardWidth;
    updateSlider();
  });

});